module.exports = __webpack_public_path__ + "static/media/hank_icon.20a0b276.svg";